import { SomethingWentWrong } from './SomethingWentWrong';

export default SomethingWentWrong;
